import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { format } from 'date-fns';
import { NavMenu } from '../components/NavMenu';
import DualBallSpinner from '../img/dual-ball-1s-100px.gif';
import { businessIdHeader, cssFormInputLabel, fetchSignedMessage, getMethod, getSessionValue, isLoggedIn, longDisplayDateAndTimeFormat } from './Library';
import { MessageSender } from './MessageSender';
import { VoucherSender } from './VoucherSender';
import ShowMessage from '../img/message_button_green.png';
import HideMessage from '../img/hide_message_button_green.png';
import ShowVoucher from '../img/vouchers_icon_green.png';
import HideVoucher from '../img/hide_vouchers_icon_green.png';

export class Reviews extends Component {
    constructor(props) {
        super(props)
        this.state = {
            reviewsData: [],
            business: null,
            loading: true
        }
    }

    async componentDidMount() {
        await isLoggedIn();
        this.getReviewsData();
    }

    async getReviewsData() {
        try {
            const businessId = getSessionValue(businessIdHeader);
            const response = await fetchSignedMessage(null, 'business/' + businessId + '/completedreviewrequests', getMethod);
            const businessResponse = await fetchSignedMessage(null, 'business/' + businessId, getMethod);
            const data = await response.json();
            const businessData = await businessResponse.json();

            this.setState({ reviewsData: data });
            this.setState({ business: businessData, loading: false });
        }
        catch (error) {
            console.log(error);
            const networkErrorEmail = "mailto:tech@receiptsandrewards.com?subject=Login%20-%20Network%20Error&body=A%20User%20is%20unable%20to%20logon%20to%20" + window.location.host;
            var messageLabel = document.getElementById("errorMessage");
            ReactDOM.render(<label className={cssFormInputLabel} >There appears to be a network error. Please <a href={networkErrorEmail}>contact Receipts and Rewards</a> and we will fix it.</label>, messageLabel);
            this.setState({ loading: false, buttonDisabled: false });
        }
    }

    toggleView = (type, reviewId) => {
        const statekey = "visible" + type + reviewId;
        this.setState({ [statekey]: !this.state[statekey] });
    }

    render() {
        return (
            <>

                <div id="reviews">
                    <NavMenu />
                    <table>
                        <tr>
                            <th>Date Sent to Customer</th>
                            <th>Rating</th>
                            <th>Feedback</th>
                            <th></th>
                            <th></th>
                        </tr>
                    {
                            this.state.reviewsData.map(reviewRequest =>
                            <tr id={reviewRequest.reviewRequestTemplateReviewId}>
                                    <td align="center">{reviewRequest.sent !== null ? format(reviewRequest.sent, longDisplayDateAndTimeFormat) : ""}</td>
                                    <td align="center">{reviewRequest.reviewRating}</td>
                                    <td>{reviewRequest.feedback}</td>
                                    <td><img title="Reply to Customer with Message" src={this.state["visiblemessage" + reviewRequest.reviewRequestTemplateReviewId] ? HideMessage : ShowMessage} className="in-table-icon" onClick={() => this.toggleView("message", reviewRequest.reviewRequestTemplateReviewId)} /></td>
                                    <td><div className={"collapse" + (this.state["visiblemessage" + reviewRequest.reviewRequestTemplateReviewId] ? ".in" : "")}><MessageSender recipients={[reviewRequest.consumerDeviceId]} /></div></td>
                                    <td><img title="Send the customer a voucher" src={this.state["visiblevoucher" + reviewRequest.reviewRequestTemplateReviewId] ? HideVoucher : ShowVoucher} className="in-table-icon" onClick={() => this.toggleView("voucher", reviewRequest.reviewRequestTemplateReviewId)} /></td>
                                    <td><div className={"collapse" + (this.state["visiblevoucher" + reviewRequest.reviewRequestTemplateReviewId] ? ".in" : "")}><VoucherSender recipients={[reviewRequest.consumerDeviceId]} /></div></td>
                            </tr>
                        )
                        }
                    </table>
                </div>
                <div id="errorMessage" />
                {this.state.loading ? <img src={DualBallSpinner} alt="Loading" /> : ''}
            </>
        );
    }

}